<div class="hx-form ant-form-vertical" *transloco="let tr; prefix: 'deliveryZones'; scope: 'delivery-zones'">
  <div nz-row>
    <nz-col [nzSpan]="24">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('modal.editDeliveryZone.storeId')}}</nz-form-label>
        <nz-form-control>
          <hx-store-select [(ngModel)]="zone.storeId" [brandId]="brandId"
                           (ngModelChange)="onStoreIdChange()"></hx-store-select>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </div>
  <div nz-row *ngIf="zone.storeId && prices.length > 0">
    <nz-col [nzSpan]="24">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('modal.editDeliveryZone.priceId')}}</nz-form-label>
        <nz-form-control>
          <nz-select [(ngModel)]="zone.priceId"
                     nzAllowClear nzShowSearch [nzDropdownMatchSelectWidth]="false">
            <nz-option *ngFor="let op of prices" [nzValue]="op.id"
                       [nzLabel]="op.value + ' / ' + op.amount"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </div>

  <nz-divider nzDashed [nzText]="tr('modal.otherStore.header')" nzOrientation="left"></nz-divider>

  <nz-table nzBordered
            [nzFrontPagination]="false"
            [nzData]="otherStores"
            [nzTotal]="otherStores.length" [nzFooter]="tableFooter">
    <thead>
    <tr>
      <th>{{tr('modal.otherStore.title')}}</th>
      <th>{{tr('modal.otherStore.priceValue')}}</th>
      <th>#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of otherStores; let ix = index">
      <td>
        {{data.storeTitle | uiLabel}}
      </td>
      <td>{{ data.priceValue }}</td>
      <td>
        <a (click)="deleteOtherStore(ix)">{{'button.delete' | transloco}}</a>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <ng-template #tableFooter>
    <form nz-form [nzLayout]="'inline'" [formGroup]="otherStoreForm" (ngSubmit)="addOtherStore()">
      <nz-form-item>
        <nz-form-control>
          <hx-store-select formControlName="storeId" [brandId]="brandId"></hx-store-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <nz-select formControlName="priceId"
                     nzAllowClear nzShowSearch [nzDropdownMatchSelectWidth]="false">
            <nz-option *ngFor="let op of newPrices" [nzValue]="op.id"
                       [nzLabel]="op.value + ' / ' + op.amount"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" [disabled]="!otherStoreForm.valid">ok</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-template>
</div>

<!--
<ng-template #modalFooter>

</ng-template>
-->

<div *nzModalFooter class="cp__buttons">
  <button (click)="closeModal()" nz-button nzType="default">{{'button.close' | transloco}}</button>
  <button (click)="ok()" nz-button nzType="primary">{{'button.ok' | transloco}}</button>
</div>
